module.exports = __webpack_public_path__ + "correct.png?4bf9e4b9f9228bbddae87ab7fee77c26";